<div class="share-class-view">
	<app-share-classes [clientCode]="entityId()" (clientShareClassClicked)="showShareholdersHandler($event)"></app-share-classes>
</div>
